import { useMutation } from '@tanstack/react-query';
import { useApiClient } from '../api';
import { type DirectSaleRequest, DirectSaleResponse, ErrorMessage } from '../../generated-api';
import { parseError } from '../utils/error-handler';

export const useMutateInitiateDirectSale = () => {
  const apiClient = useApiClient();
  return useMutation<DirectSaleResponse, ErrorMessage, DirectSaleRequest>({
    mutationKey: ['init-payment'],
    mutationFn: async (req: DirectSaleRequest) => {
      try {
        return await apiClient.F1ControllerApi.directSalePayment({
          directSaleRequest: req,
        });
      } catch (err) {
        throw (await parseError(err)) as ErrorMessage;
      }
    },
  });
};
